import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { AnalyticsPage } from '@/pages/analytics/AnalyticsPage';
import { ReportsPage } from '@/pages/analytics/ReportsPage';
import { RealtimePage } from '@/pages/analytics/RealtimePage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { UserDetailPage } from './pages/users/UserDetails/UserDetailPage';
import KycInfo from './pages/users/Create/KycInfo';
import { BankAccounts } from './pages/Bank/BankAccounts';
import { UpiAccounts } from './pages/Bank/UpiAccounts';
import CreateBankAccount from './pages/Bank/Create/CreateBankAccount';
import CreateUpiAccount from './pages/Bank/Create/CreateUpiAccount';
import { DepositRequest } from './pages/Transactions/DepositRequest';
import { WithdrawRequest } from './pages/Transactions/WithdrawRequest';
import { TrusteeKycRequest } from './pages/Kyc/TrusteeKycRequest';
import UserKycRequest from './pages/Kyc/UserKycRequest';
import CompanyKycRequest from './pages/Kyc/CompanyKycRequest';
import MasterRwaForm from './pages/MasterRWA/MasterRWAForm';
import ChangePassword from './pages/ChangePassword';
import { ProfilePage } from './pages/Profile/ProfilePage';
import CreateUser from './pages/users/Create/CreateUser';
import { AssetList } from './pages/Asset/AssetList';
import AssetDetailsPage from './pages/Asset/AssetDetailsPage';
import NotificationListener from './components/Notification/NotificationListener';
import { Toaster } from 'react-hot-toast';
import NotificationsPage from './pages/NotificationsPage';
import TrusteeKycDetails from './pages/Kyc/TrusteeKycDetails';
import UserKycDetails from './pages/Kyc/UserKycDetails';
import CompanyKycDetails from './pages/Kyc/CompanyKycDetails';
import { CouponsPage } from './pages/Coupon/CouponPage';
import CreateCoupon from './pages/Coupon/CreateCoupon';
import EditAssetPage from './pages/Asset/EditAssetPage';
import { LegalComplianceVendorsPage } from './pages/Vendors/LegalComplianceVendorsPage';
import CreateVendorPage from './pages/Vendors/CreateVendorPage';
import { LeadDetails } from './pages/users/UserDetails/LeadDetails';
import { BrokerCommissions } from './pages/users/UserDetails/CommissionPage';
import { Groups } from './pages/Groups';
import CreateGroup from './pages/Groups/Create/CreateGroup';
import { Category } from './pages/Category';
import CreateCategory from './pages/Category/Create/CreateCategory';
import { GroupDetailsPage } from './pages/Groups/GroupDetails/GroupDetailsPage';
import ShareToGroups from './pages/Groups/GroupDetails/ShareToGroups';
import { IntrestedMember } from './pages/Groups/GroupDetails/IntrestedMember';
import { PaymentMember } from './pages/Groups/GroupDetails/PaymentMember';
import EditGroup from './pages/Groups/Create/EditGroup';
import EditVendorPage from './pages/Vendors/EditVendorPage';
import { ImmediateSalePage } from './pages/Groups/GroupDetails/ImmediateSalePage';

export function App() {
  return (
    <>
      <NotificationListener />
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          {/* <Route path="/register" element={<RegisterPage />} /> */}
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            {/* Analytics Routes */}
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/analytics/reports" element={<ReportsPage />} />
            <Route path="/analytics/realtime" element={<RealtimePage />} />
            {/* Settings Routes */}
            <Route path="/settings" element={<SettingsPage />} />
            {/* Form Examples */}
            <Route path="/forms" element={<SimpleFormPage />} />
            <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} />
            <Route path="/vendors/create" element={<CreateVendorPage />} />
            <Route path="/vendors/edit/:id" element={<EditVendorPage />} />
            <Route path="/vendors-page" element={<LegalComplianceVendorsPage />} />{' '}
            {/* new ttoo update */}
            {/* Admin Routes */}
            <Route element={<AdminRoute />}>
              {/* <Route path="/admin/broker/lead-details/:id" element={<LeadDetails />} /> */}
              <Route
                path="/users/:userType/detail/:userId/leads/:id"
                element={<LeadDetails />}
              />{' '}
              {/* new 5 update */}
              <Route path="/commissions" element={<BrokerCommissions brokerId={0} />} />
              <Route path="/users/:userType" element={<UsersPage />} />
              <Route path="/groups" element={<Groups />} />
              <Route path="/category" element={<Category />} />
              {/* <Route path="/user-detail/:id" element={<UserDetailPage />} /> */}
              <Route path="/users/:userType/detail/:id" element={<UserDetailPage />} />{' '}
              <Route path="/group/detail/:id" element={<GroupDetailsPage />} />
              <Route
                path="/group/intrested-member/:groupId/:propertyId"
                element={<IntrestedMember />}
              />
              <Route
                path="/group/payments/:groupId/:propertyId"
                element={<PaymentMember />}
              />
              <Route
                path="/group/immediate-sale/:groupId/:propertyId"
                element={<ImmediateSalePage />}
              />
              <Route path="/group/share/:id" element={<ShareToGroups />} />
              {/* new 5 update */}
              <Route path="/create-user/:userType" element={<CreateUser />} />
              <Route path="/create-group" element={<CreateGroup />} />
              <Route path="/edit-group/:id" element={<EditGroup />} />
              <Route path="/create-category" element={<CreateCategory />} />
              <Route path="/create-investor/kyc/:id" element={<KycInfo />} />
              <Route path="/bank-account" element={<BankAccounts />} />
              <Route path="/upi" element={<UpiAccounts />} />
              <Route path="/add-bank-account" element={<CreateBankAccount />} />
              <Route path="/add-upi" element={<CreateUpiAccount />} />
              <Route path="/deposit-request" element={<DepositRequest />} />
              <Route path="/withdraw-request" element={<WithdrawRequest />} />
              <Route path="/trustee-kyc-request" element={<TrusteeKycRequest />} />
              <Route path="/user-kyc-request" element={<UserKycRequest />} />
              <Route path="/company-kyc-request" element={<CompanyKycRequest />} />
              {/* <Route path="/trustee-kyc-details/:id" element={<TrusteeKycDetails />} /> */}
              <Route path="/trustee-kyc-request/:id" element={<TrusteeKycDetails />} />
              <Route path="/user-kyc-request/:id" element={<UserKycDetails />} />
              <Route path="/company-kyc-request/details/:id" element={<CompanyKycDetails />} />
              <Route path="/master-rwa-form" element={<MasterRwaForm />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/asset-list" element={<AssetList />} />
              {/* <Route path="/asset-detail/:id" element={<AssetDetailsPage />} /> */}
              <Route path="/asset-list/assets/:assetId" element={<AssetDetailsPage />} />{' '}
              {/* new 5 update */}
              <Route path="/edit-asset/:id" element={<EditAssetPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/coupon-page" element={<CouponsPage />} />
              <Route path="/create-coupon" element={<CreateCoupon />} />
              <Route path="/vendors-page" element={<LegalComplianceVendorsPage />} />
            </Route>
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 6000,
        }}
      />
    </>
  );
}
